import { Trans } from '@lingui/react/macro';
import { ActivityEntry, ActivityEntryText } from 'app/domains/common-ui/ActivityLog';
import { getIcon } from './utils';
export function ApprovalRequestApproved(props) {
    const { timestamp } = props;
    return (<ActivityEntry appearance="success" icon={getIcon('success')} timestamp={timestamp} text={<ActivityEntryText>
          <Trans comment="Approval activity - Request fully approved">The request was fully approved</Trans>
        </ActivityEntryText>}/>);
}
